import {GetExamsDatesParams} from 'domain/usecases';
import {makeGetExamsDates} from 'main/factories/usecases';
import {sortDateStringArray} from 'presentation/utils';

async function getExamsDates(params: GetExamsDatesParams) {
	const dates = await makeGetExamsDates().get(params);

	if (!dates) {
		return [];
	}

	return sortDateStringArray(dates);
}

export {getExamsDates};
